const offerings = [
  {
    title: "Off-the-Shelf SaaS Solutions",
    desc: "Ready-to-deploy systems for workforce management, HR, performance tracking, operations, and billing.",
  },
  {
    title: "Bespoke Software Development",
    desc: "Custom-built solutions tailored to specific business needs, workflows, and operational structures.",
  },
  {
    title: "System Integration",
    desc: "Unifying processes, platforms, and data sources into a single coherent operational backbone.",
  },
  {
    title: "Operational Structure",
    desc: "Technology-driven systems that bring order, visibility, and control to how work gets done.",
  },
];

export default function WhatWeDo() {
  return (
    <section className="py-16 md:py-24 bg-graphite-850">
      <div className="w-full px-4 sm:px-6 lg:px-8 xl:px-16">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12 md:mb-16">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-graphite-700 bg-graphite-800/50 mb-6">
              <span className="text-xs font-medium text-silver-300 tracking-wide">What We Do</span>
            </div>
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-white mb-4">What We Do</h2>
            <p className="text-base md:text-lg text-silver-300 max-w-2xl mx-auto leading-relaxed">
              StackMap provides a full spectrum of solutions, from ready-to-use platforms to fully custom builds.
            </p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 md:gap-6">
            {offerings.map((o) => (
              <div key={o.title} className="glass-card p-6 md:p-7 flex flex-col gap-3 group">
                <h3 className="text-base md:text-lg font-bold text-white group-hover:text-emerald-soft transition-colors duration-300">{o.title}</h3>
                <p className="text-sm text-silver-400 leading-relaxed">{o.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
